import React from "react";
import { Link } from "gatsby";
import { motion } from "framer-motion";
import Navbar from "../component/Navbar/Navbar";
import Footer from "../component/Footer/Footer";
import ReactWebImg from "../static/img/react-web.jpg";
import ReactIcon from "../static/img/react-icon.png";
import AccordionItem from "../component/Courses/AccordionItem";
import ContactForm from "../component/Courses/ContactForm";
import MetaTags from "../component/MetaTags";
import Price from "../component/Price";

const reactdevelopercourse = () => {
  const pageVariants = {
    initial: {
      opacity: 0,
    },
    in: {
      opacity: 1,
    },
    out: {
      opacity: 0,
    },
  };

  return (
    <>
      <Navbar />
      <motion.div
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
      >
        <section id="courses-sec" className="course-banner">
          {/* <div className={"page_header m-auto"}>
            <div className={"row align-items-center"}> */}
              <div className={" language-content"}>
                <h1 align="center">
                  REACT JS SUMMER TRAINING <br />
                  THE BEST REACT JS ONLINE COURSE
                </h1>
                  <p align="center">
                    {
                      "Level up your web development skills with our React JS Summer Training! Immerse yourself in the realm of React JS and master the art of front-end development through our all-inclusive online course."
                    }
                    <br />
                    {
                      "Join us for the best React JS online course and take your coding skills to new heights!"
                    }
                  </p>
                  <Price buy={true} />
                </div>
              {/* </div> */}
              <div className="japanese-form">
                <ContactForm />
            
            </div>
        

        </section>

        <h3 className="courses__joinUs"></h3>
        <section id="courses__about" className="courses__about">
          <h3 align="center" className="light-text">
            ABOUT <span className="highlighted-text">REACT JS ONLINE TRAINING</span> 
          </h3>
          <div className="container pt-4 d-flex flex-column gap-5">
            <div className="row">
              <div className="col-sm-6 d-flex justify-content-center">
                <img src={ReactWebImg} alt="" className="courses__about-img" />
              </div>
              <div className="col-sm-6 d-flex align-items-center mt-4 mt-md-0">
                <div className="courses__about__content">
                  <p>
                    {
                      "We are dedicated to providing the best learning experience for aspiring developers and professionals seeking to enhance their skills in React JS. With a comprehensive curriculum and a team of expert MNC professionals as our instructors, we ensure that you receive top-class training that aligns with industry standards."
                    }
                  </p>
                  <p>
                    {
                      "From the fundamentals to advanced concepts, our expert instructors will guide you through hands-on projects, real-world examples, and industry best practices. Don't miss out on this opportunity to enhance your coding prowess and create dynamic, interactive web applications."
                    }
                  </p>
                </div>
              </div>
            </div>

            <div className="row course-highlights">
              <h3 className="ms-3 font-weight-bolder">Program Highlights</h3>
              <div className="col-sm-12 col-md-12 mt-2">
                <div className="row">
                  <div className="col-sm-6 col-md-6">
                    <p className="course-highlights__content d-flex gap-2">
                      <span>📌</span>
                      <span>A one-month intensive training program.</span>
                    </p>
                  </div>{" "}
                  <div className="col-sm-6 col-md-6">
                    <p className="course-highlights__content d-flex gap-2">
                      <span>📌</span>
                      <span>
                        {" "}
                        Industry-leading professionals from multinational
                        companies as instructors.
                      </span>
                    </p>
                  </div>
                  <div className="col-sm-6 col-md-6">
                    <p className="course-highlights__content d-flex gap-2">
                      <span>📌</span>
                      <span>
                        Hands-on practical training to enhance your skills.
                      </span>
                    </p>
                  </div>
                  <div className="col-sm-6 col-md-6">
                    <p className="course-highlights__content d-flex gap-2">
                      <span>📌</span>
                      <span>
                        Syllabus designed to align with industry requirements
                        and job market demands.
                      </span>
                    </p>
                  </div>
                  <div className="col-sm-6 col-md-6">
                    <p className="course-highlights__content d-flex gap-2">
                      <span>📌</span>
                      <span>
                        Dedicated doubt-clearing sessions for a comprehensive
                        understanding.
                      </span>
                    </p>
                  </div>
                  <div className="col-sm-6 col-md-6">
                    <p className="course-highlights__content d-flex gap-2">
                      <span>📌</span>
                      <span>
                        Internship assistance for valuable real-world
                        experience.
                      </span>
                    </p>
                  </div>
                  <div className="col-sm-6 col-md-6">
                    <p className="course-highlights__content d-flex gap-2">
                      <span>📌</span>
                      <span>
                        Coaching that caters to beginners as well as experts.
                      </span>
                    </p>
                  </div>
                  <div className="col-sm-6 col-md-6">
                    <p className="course-highlights__content d-flex gap-2">
                      <span>📌</span>
                      <span>Valid certificate upon successful completion.</span>
                    </p>
                  </div>
                  <div className="col-sm-6 col-md-6">
                    <p className="course-highlights__content d-flex gap-2">
                      <span>📌</span>
                      <span>
                        {" "}
                        Affordable fee structure for accessible learning
                        opportunities.
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="row course-syllabus">
              <h3 className="light-text text-center">
                What <span className="highlighted-text"> You Will Learn</span> 
              </h3>
              <div className="d-flex flex-column flex-lg-row gap-5 mt-4">
                <ul className="course-syllabus__list">
                  <AccordionItem
                    className="course-syllabus__list-item"
                    title="React Home"
                  >
                    <ul>
                      <li>React Intro</li>
                      <li>React Get Started</li>
                      <li>React ES6 </li>
                      <li>React Render HTML</li>
                    </ul>
                  </AccordionItem>
                  <AccordionItem
                    className="course-syllabus__list-item"
                    title="React Essentials"
                  >
                    <ul>
                      <li>React JSX</li>
                      <li>React Components</li>
                      <li>React Classes</li>
                      <li>React Props</li>
                      <li>React Props</li>
                      <li>React Lists</li>
                      <li>React Forms</li>
                    </ul>
                  </AccordionItem>
                  <AccordionItem
                    className="course-syllabus__list-item"
                    title="React Router and Styling"
                  >
                    <ul>
                      <li>React Router</li>
                      <li>React Memo</li>
                      <li>React CSS Styling</li>
                      <li>React Sass Styling</li>
                    </ul>
                  </AccordionItem>
                  <AccordionItem
                    className="course-syllabus__list-item"
                    title="React Hooks"
                  >
                    <motion.ul>
                      <li>What is a Hook?</li>
                      <li>useState</li>
                      <li>useEffect</li>
                      <li>useContext</li>
                      <li>useRef</li>
                      <li>useReducer</li>
                      <li>useCallback</li>
                      <li>useMemo</li>
                      <li>Custom Hooks</li>
                    </motion.ul>
                  </AccordionItem>
                  <AccordionItem
                    className="course-syllabus__list-item"
                    title="React Exercises"
                  >
                    <ul>
                      <li>React Exercises</li>
                      <li>React Compiler</li>
                      <li>React Quiz</li>
                      <li>React Certificate</li>
                    </ul>
                  </AccordionItem>
                </ul>
                <img
                  src={ReactIcon}
                  style={{ justifySelf: "start" }}
                  alt=""
                  className=""
                />
              </div>
            </div>
          </div>
          <section
            id="services"
            className="advance"
            style={{ marginTop: "4rem" }}
          >
            <div className="container">
              <header className="section-header">
                <h3 className="light-text"> WHY <span className="highlighted-text"> KODERBOX TECHNOLOGIES?</span> </h3>
              </header>
              <br />
              <div className="">
                <div
                  className="col-md-12  wow bounceInUp "
                  data-wow-duration="1.4s"
                >
                  <div className="box blank_service">
                    <div className="row">
                      <div
                        className="col-md-6  wow bounceInUp "
                        data-wow-duration="1.4s"
                      >
                        <div className="box box-2 blank_service">
                          <p>
                            <div className={"row"}>
                              <div className={"col-sm-12"}>
                                Our training program is led by expert
                                instructors who have extensive industry
                                experience. They possess in-depth knowledge of
                                React JS and are committed to providing
                                top-level education to help you succeed.
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                      <div
                        className="col-md-6  wow bounceInUp "
                        data-wow-duration="1.4s"
                      >
                        <div className="box box-2 blank_service">
                          <p>
                            <div className={"row"}>
                              <div className={"col-sm-12"}>
                                We prioritize practical training to ensure you
                                acquire hands-on experience. Through real-world
                                projects, coding exercises, and interactive
                                sessions, you will gain the skills and
                                confidence needed to excel in React JS
                                development.
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-4">
                      <div
                        className="col-md-6  wow bounceInUp "
                        data-wow-duration="1.4s"
                      >
                        <div className="box box-2 blank_service">
                          <p>
                            <div className={"row"}>
                              <div className={"col-sm-12"}>
                                Our training program is designed with a
                                job-oriented mindset. The syllabus is carefully
                                crafted to cover the most in-demand React JS
                                concepts and techniques, equipping you with the
                                skills that employers seek.
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                      <div
                        className="col-md-6  wow bounceInUp "
                        data-wow-duration="1.4s"
                      >
                        <div className="box box-2 blank_service">
                          <p>
                            <div className={"row"}>
                              <div className={"col-sm-12"}>
                                We offer dedicated doubt-clearing sessions where
                                our instructors address your queries and provide
                                additional guidance, ensuring a clear
                                understanding of the subject matter.
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-4">
                      <div
                        className="col-md-6  wow bounceInUp "
                        data-wow-duration="1.4s"
                      >
                        <div className="box box-2 blank_service">
                          <p>
                            <div className={"row"}>
                              <div className={"col-sm-12"}>
                                We offer our training program at an affordable
                                fee, making it accessible to a wider audience.
                                Additionally, we provide flexible scheduling
                                options to accommodate different learning needs
                                and availability.
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                      <div
                        className="col-md-6  wow bounceInUp "
                        data-wow-duration="1.4s"
                      >
                        <div className="box box-2 blank_service">
                          <p>
                            <div className={"row"}>
                              <div className={"col-sm-12"}>
                                Take a step towards mastering React JS and
                                unlocking exciting opportunities in the world of
                                web development.
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
            </div>
          </section>

          {/* <section className="join container">
            <div className="join__layer">
              <div className="join__layer-1">
                <h1>
                  Take the first step towards a successful career in web
                  development with us.
                </h1>
                <p>
                  Join our React JS Training program and find the potential to
                  build dynamic and interactive web applications using this
                  popular JavaScript library.
                </p>
              </div>
              <div className="join__layer-2">
                <h2>Contact</h2>
                <div className="join__layer-2--form-control">
                  <label for="full-name">Full Name</label>
                  <input type="text" id="full-name" name="full-name" />
                </div>
                <div className="join__layer-2--form-control">
                  <label for="email">Email</label>
                  <input type="email" id="email" name="email" />
                </div>
                <button>Contact Now</button> */}
                {/* <p className="text-xs text-gray-500 mt-3">
                  Literally you probably haven't heard of them jean shorts.
                </p> */}
              {/* </div>
            </div>
          </section> */}
        </section>
      </motion.div>
      <Footer />
      <MetaTags
        title="React JS Developer Course Online | Koderbox"
        description="Learn React JS with Koderbox's live online course — build real projects, learn from expert trainers, and get job-ready. Book a free demo."
        path="/reactdevelopercourse/"
      />
    </>
  );
};

export default reactdevelopercourse;
